import React, { createContext, useContext, useEffect, useState } from 'react';
import { loadResx, createTranslator } from '../shared/helpers/resourceLoader';
import { useSelectedDealership } from '../hooks/useLocalStorage';
import apiManager from '../api/apiManager';
import API_ENDPOINTS from '../api/apiEndpoints';

const LocalizationContext = createContext({ t: (k) => k, language: 'en' });

export const LocalizationProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');
  const [t, setT] = useState(() => (key, params) => key);
  const [selectedDealershipId] = useSelectedDealership();

  useEffect(() => {
    let mounted = true;
    const load = async (lang) => {
      try {
        const resources = await loadResx(lang || 'en');
        const translator = createTranslator(resources);
        if (!mounted) return;
        setLanguage(lang || 'en');
        setT(() => translator);
      } catch (err) {
        setLanguage('en');
        setT(() => ((k) => k));
      }
    };

    const fetchDealershipLanguage = async (id) => {
      if (!id) return load('en');
      try {
        const res = await apiManager.post(API_ENDPOINTS.DEALER_GET_ID, { id });
        if (res && res.status === 200 && res.data) {
          const lang = res.data.languageCode || res.data.locale || res.data.lang || 'en';
          await load(lang);
        } else {
          await load('en');
        }
      } catch (err) {
        await load('en');
      }
    };

    fetchDealershipLanguage(selectedDealershipId);

    return () => { mounted = false; };
  }, [selectedDealershipId]);

  return (
    <LocalizationContext.Provider value={{ t, language }}>
      {children}
    </LocalizationContext.Provider>
  );
};

export const useLocalization = () => useContext(LocalizationContext);

export default LocalizationContext;
